import type { PopoverWidth } from "@mantine/core";
import { ActionIcon, Group, Menu } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import "./MantineActionCell.scss";

/**
 * Props for MantineActionCell.
 * @property {React.ReactNode} children - Content to display in the cell.
 * @property {React.ReactNode} menuDropdown - Expects <Menu.Dropdown> element..
 */
export interface MantineActionCellProps {
  children: React.ReactNode;
  menuDropdown: React.ReactElement<typeof Menu.Dropdown>;
  menuWidth?: PopoverWidth;
  iconTitle?: string;
}

function MantineActionCell({
  children,
  menuDropdown,
  menuWidth,
  iconTitle = "Aktionen"
}: MantineActionCellProps) {
  return (
    <Group className="MantineActionCell" justify="space-between">
      {children}
      <Menu shadow="md" width={menuWidth}>
        <Menu.Target>
          <ActionIcon variant="transparent">
            <IconDotsVertical
              className="icon-menu"
              size={16}
              title={iconTitle}
            />
          </ActionIcon>
        </Menu.Target>
        {menuDropdown}
      </Menu>
    </Group>
  );
}
export { MantineActionCell };
